export class ElementoTMM {
	id: number = 0;
	nombre: string = "";
}